<template>
  <row-item :disabled="disabled"
            type="gradient-primary"
            @click="handleClick"
  >
    <template v-if="product.type === 'coinProduct'">
      即将上架
    </template>
    <template v-else>
      {{ sell.startTime }}{{ startHint }}
    </template>
  </row-item>
</template>

<script>
  import RowItem from '@/components/YmTabbarItem/Row';

  export default {
    name: 'ProductDetailBottomUnStartBar',
    components: {
      RowItem,
    },
    data() {
      return {
        disabled: false,
      };
    },
    props: {
      sell: {
        type: Object,
        required: true,
      },
      product: {
        type: Object,
        required: true,
      },
      startHint: {
        type: String,
        default: '开售',
      },
    },
    methods: {
      handleClick() {
        if (this.disabled) return;
        this.disabled = true;
        const hint = this.product.type === 'coinProduct' ? '即将上架' : `尚未${this.startHint}`;
        this.$toast(hint);
        this.disabled = false;
      },
    },
  };
</script>
